import { render, staticRenderFns } from "./BrowsingHistoryExhibitors.vue?vue&type=template&id=9889fc6a&scoped=true&"
import script from "./BrowsingHistoryExhibitors.vue?vue&type=script&lang=js&"
export * from "./BrowsingHistoryExhibitors.vue?vue&type=script&lang=js&"
import style0 from "./BrowsingHistoryExhibitors.vue?vue&type=style&index=0&id=9889fc6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9889fc6a",
  null
  
)

export default component.exports